import BannerInfo from "../Components/BannerInfo/BannerInfo";
import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Header";
import TextInfo from "../Components/TextInfo/TextInfo";
import { bgColorPolicy, logoHeaderTerms, navLinksPolicy, navLinksRedPolicy, soluctionLinksPolicy, textColorPolicy, textPolicy, titleBannerPolicy } from "./Config";
import logo from './../Images/Icone_Fundo_Transparente.webp';

const Policy = () => {
    return (
        <>
            <Header logo={logo}
                bgColor={bgColorPolicy}
                textColor={textColorPolicy}
                linkContact={textPolicy}
                soluctionLinks={soluctionLinksPolicy}
                logoSize="w-15 h-20 p-2"
                navLinks={navLinksPolicy}/>
            <BannerInfo title={titleBannerPolicy} />
            <TextInfo sections={textPolicy}/>
            <Footer />
        </>

    )
}

export default Policy;